// src/context/LoadingContext.jsx
import React, { createContext, useState, useContext, useCallback } from 'react';
import Loading from '../components/Loading/Loading';

const LoadingContext = createContext({});

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('A carregar...');

  const showLoading = useCallback((message = 'A carregar...') => {
    setLoadingMessage(message);
    setIsLoading(true);
  }, []);

  const hideLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  const withLoading = useCallback(async (fn, message = 'A processar...') => {
    showLoading(message);
    try {
      const result = await fn();
      return result;
    } finally {
      hideLoading();
    }
  }, [showLoading, hideLoading]);

  return (
    <LoadingContext.Provider value={{ isLoading, showLoading, hideLoading, withLoading, loadingMessage }}>
      {children}
      {isLoading && <Loading message={loadingMessage} />}
    </LoadingContext.Provider>
  );
};